<div class='graph-tab container-fluid'>
  <div class='row'>
    <mat-card class=' col-12'>
      <mat-card-header class='modal-header'>
        <mat-card-title>{{ 'website.equipment.config.performance.startup_per_engines' | translate }}</mat-card-title>
      </mat-card-header>


      <mat-card-content>
        <div class='row'>
          <mat-form-field appearance='outline' (click)='instDatePicker.open()' class='mt-4 col-md-3  pv-sm-field col-12'>
            <mat-label>{{ 'website.equipment.detail.charts.period' | translate }}</mat-label>
            <input
              matInput
              (dateChange)='changeDatePicker($event)'
              [matDatepickerFilter]='instDatePickerFilter'
              [matDatepicker]='instDatePicker'
              value='{{currentDayDate}}'
              readonly
              formControlName='instDateFilter'
            />
            <mat-datepicker-toggle matSuffix [for]='instDatePicker'>
              <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
            </mat-datepicker-toggle>
            <mat-datepicker #instDatePicker></mat-datepicker>
          </mat-form-field>
        </div>
        <div class='row ' *isLoading='{isLoading:!readyToRender,hasContent:dataSource.data?.length>0}'>
          <div class='col-12 overflow-x-auto p-0'>
            <table mat-table [dataSource]='dataSource' *ngIf='dataSource.data?.length>0' >
              <ng-container matColumnDef='label'>
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell class='a-center fw-bold' *matCellDef='let element'>
                  <div style='min-width: 160px; margin-left: 55px; font-family: Montserrat, sans-serif; font-size: 14px;'>
                    {{ element.name }}
                  </div>
                </td>
              </ng-container>

              <ng-container matColumnDef='chronogramme'>
                <th mat-header-cell *matHeaderCellDef>
                  <div class='d-flex justify-content-between mat-mdc-header-cell'>
                    <div class='d-flex'>00:00</div>
                    <div class='d-flex'>24:00</div>
                  </div>

                </th>
                <td mat-cell class='a-center' *matCellDef='let element'>
                  <app-equipment-performances-charts
                    [data]='element'
                    [minDate]='this.instCriteria.filters.minDate'
                    [maxDate]='this.instCriteria.filters.maxDate'
                    [width]='400'>
                  </app-equipment-performances-charts>
                </td>
              </ng-container>

              <ng-container matColumnDef='tempsTotal'>
                <th mat-header-cell *matHeaderCellDef><p>{{ 'website.equipment.config.performance.total_work_time' | translate }}</p></th>
                <td mat-cell class='a-center' *matCellDef='let element'>{{element.performanceData.tempsTotal }}</td>
              </ng-container>

              <ng-container matColumnDef='freqDemar'>
                <th mat-header-cell *matHeaderCellDef><p>{{ 'website.equipment.config.performance.startup_frequency' | translate }}</p></th>
                <td mat-cell class='a-center' *matCellDef='let element'>{{element.performanceData.freqDemar}}</td>
              </ng-container>

              <ng-container matColumnDef='tpsMinBetweenDemar'>
                <th mat-header-cell *matHeaderCellDef><p>{{ 'website.equipment.config.performance.time_btw_stup' | translate }}</p></th>
                <td mat-cell class='a-center' *matCellDef='let element'>{{element.performanceData.tpsMinBetweenDemar}}</td>
              </ng-container>

              <ng-container matColumnDef='tpsMinWorking'>
                <th mat-header-cell *matHeaderCellDef><p>{{ 'website.equipment.config.performance.min_work_time' | translate }}</p></th>
                <td mat-cell class='a-center' *matCellDef='let element'>{{element.performanceData.tpsMinWorking  }}</td>
              </ng-container>

              <ng-container matColumnDef='tpsMaxWorking'>
                <th mat-header-cell *matHeaderCellDef><p>{{ 'website.equipment.config.performance.max_work_time' | translate }}</p></th>
                <td mat-cell class='a-center' *matCellDef='let element'>{{element.performanceData.tpsMaxWorking}}</td>
              </ng-container>



              <tr mat-header-row *matHeaderRowDef='displayedColumns'></tr>
              <tr mat-row *matRowDef='let row; columns: displayedColumns;' (click)="openEquipmentUserModal(row)"></tr>

              <!-- Group header -->
              <ng-container matColumnDef="groupHeader">
                <td colspan="999" mat-cell *matCellDef="let group">
                  <mat-icon class='pt-2 me-2' *ngIf="group.expanded">expand_less</mat-icon>
                  <mat-icon class='pt-2 me-2' *ngIf="!group.expanded">expand_more</mat-icon>
                  <strong style='font-family: Montserrat, sans-serif;font-size: 14px;'>{{group[groupByColumns[group.level-1]] | titlecase}}</strong>
                </td>
              </ng-container>

              <tr style='cursor: pointer' mat-row *matRowDef="let row; columns: ['groupHeader']; when: isGroup" (click)="groupHeaderClick(row)"> </tr>
            </table>
   </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>
